import { ClipboardList, CheckCircle, Clock } from "lucide-react";
import { useState, useEffect } from "react";
import { authFetch } from "../../../api";

export default function DashboardStats() {
  const userId = localStorage.getItem("userId");
  const [count, setCount] = useState({
    assigned: 0,
    completed: 0,
    pending: 0,
  });

  const fetchCount = async () => {
    try {
      const response = await authFetch("timeline/show-task-status-count", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId }),
      });

      const res = await response.json();

      if (res.success) {
        setCount({
          assigned: Number(res.data.assigned) || 0,
          completed: Number(res.data.completed) || 0,
          pending: Number(res.data.pending) || 0,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCount();
  }, []);

  const stats = [
    {
      label: "Assigned Task",
      value: count.assigned,
      icon: ClipboardList,
      stripColor: "bg-[#572575]",
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600",
    },
    {
      label: "Completed Task",
      value: count.completed,
      icon: CheckCircle,
      stripColor: "bg-[#572575]",
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-600",
    },
    {
      label: "Pending Task",
      value: count.pending,
      icon: Clock,
      stripColor: "bg-[#572575]",
      iconBg: "bg-red-100",
      iconColor: "text-red-600",
    },
  ];

  return (
    <div className="bg-white rounded-xl p-4 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {stats.map((item, index) => {
          const Icon = item.icon;

          return (
            <div
              key={index}
              className="relative flex items-center justify-between rounded-xl border border-gray-100 bg-white p-4"
            >
              <span
                className={`absolute left-0 top-0 h-full w-1.5 rounded-l-xl ${item.stripColor}`}
              />

              <div className="pl-3">
                <h3 className="text-2xl font-bold text-[#572575]">
                  {item.value}
                </h3>
                <p className="text-sm text-[#444444] font-inter font-semibold">
                  {item.label}
                </p>
              </div>

              <div
                className={`w-10 h-10 flex items-center justify-center rounded-full ${item.iconBg}`}
              >
                <Icon className={`w-5 h-5 ${item.iconColor}`} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
